import API from "@aws-amplify/api";
import { getCurrentJwt } from "../../../../util/jwt/decryptToken"

export async function fetchAudienceSegments() {
  const options = {
    headers: {
      Authorization: getCurrentJwt()
    },
    body: {
    },
  };

  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await API.get(process.env.REACT_APP_AMPLIFY_API, '/audience-builder/audience-segments', options).then(data => data)
      return res
    }
    catch (e) {
      console.log(e)
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataFetches/fetchAudienceSegments.js